import { render, staticRenderFns } from "./Glory.vue?vue&type=template&id=4e94576e&scoped=true&"
import script from "./Glory.vue?vue&type=script&lang=js&"
export * from "./Glory.vue?vue&type=script&lang=js&"
import style0 from "./Glory.vue?vue&type=style&index=0&id=4e94576e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e94576e",
  null
  
)

export default component.exports